import Modal from 'bootstrap/js/dist/modal';

// Add your custom JS here.
jQuery(document).ready(function () {
    var headerBannerParticleContainer = document.getElementById("homeBannerParticles");
    if (headerBannerParticleContainer) {
        particlesJS.load('homeBannerParticles', directory_uri.stylesheet_directory_uri + '/assets/configs/banner-particles.json', function () {
            console.log('callback - particles.js config loaded');
        });
    }

    //tmp fix
    setInterval(() => {
        const el = document.querySelector('.gaugeValueLabel');
        if (el) {
            el.textContent = el.textContent.replace(/,/g, '');
        }
    }, 1000); // every second

    //Maybe consider this one: https://github.com/toorshia/justgage
    var opts = {
        angle: 0.15,
        lineWidth: 0.10,
        colorStart: '#FFF',
        colorStop: '#FFF',
        strokeColor: '#023375',
        shadowColor: 'rgba(0,0,0,0)', //Remove shadow
        generateGradient: false,
        highDpiSupport: true
    };

    var foodGaugeTarget = document.getElementById('foodGauge');
    var nutriGaugeTarget = document.getElementById('compGauge');
    var catGaugeTarget = document.getElementById('catGauge');

    if (foodGaugeTarget && nutriGaugeTarget && catGaugeTarget) {
        fetch(myEnv.apiUrl + '/food/count')
            .then(res => res.json())
            .then(number => {
                var foodDonutGauge = new Donut(foodGaugeTarget).setOptions(opts);
                foodDonutGauge.setTextField(document.getElementById("foodGauge-textfield"));
                foodDonutGauge.maxValue = number;
                foodDonutGauge.setMinValue(0);
                foodDonutGauge.animationSpeed = 100;
                foodDonutGauge.set(number);

                var nutriDonutGauge = new Donut(nutriGaugeTarget).setOptions(opts);
                nutriDonutGauge.setTextField(document.getElementById("compGauge-textfield"));
                nutriDonutGauge.maxValue = 50;
                nutriDonutGauge.setMinValue(0);
                nutriDonutGauge.animationSpeed = 100;
                nutriDonutGauge.set(50);

                var catDonutGauge = new Donut(catGaugeTarget).setOptions(opts);
                catDonutGauge.setTextField(document.getElementById("catGauge-textfield"));
                catDonutGauge.maxValue = 276;
                catDonutGauge.setMinValue(0);
                catDonutGauge.animationSpeed = 100;
                catDonutGauge.set(276);
            });
    }

    //Custom modal before Excel download
    /*const downloadButtons = document.querySelectorAll(".btn-download-excel");

    downloadButtons.forEach(btn => {
        let foundButton = btn;

        // If the button is not an <a> or <button>, we need to find the actual button inside it
        if (btn.tagName.toLowerCase() !== 'a' && btn.tagName.toLowerCase() !== 'button') {
          //Most likely a div but there will be a <a> or <button> inside, so we need to get it
          const innerBtn = btn.querySelector('a, button');
          foundButton = innerBtn;
        }

        foundButton.addEventListener("click", function (e) {
            e.preventDefault();

            const alreadyAnswered = localStorage.getItem("excelSurveyDone");

            if (alreadyAnswered) {
                //triggerDownload();
            } else {
                // Open Bootstrap modal
                const modal = new Modal(document.getElementById('areaSurveyModal'));
                modal.show();
            }
        });
    });*/
});